import {
  SET_BANKS,
  SET_CASHIERS,
  SET_FINANCIAL,
  SET_FINANCIALS,
  SET_FUNDS,
} from "../../constants/financialConstants";

export const setFinancial = (financial) => {
  return {
    type: SET_FINANCIAL,
    financial,
  };
};

export const setFinancials = (financials, filtered = false) => {
  return {
    type: SET_FINANCIALS,
    financials,
    filtered,
  };
};

export const setBanks = (banks, filtered = false) => {
  return {
    type: SET_BANKS,
    banks,
    filtered,
  };
};

export const setFunds = (funds, filtered = false) => {
  return {
    type: SET_FUNDS,
    funds,
    filtered,
  };
};

export const setCashiers = (cashiers, filtered = false) => {
  return {
    type: SET_CASHIERS,
    cashiers,
    filtered,
  };
};
